import { Map, List } from 'immutable';

import { FETCH_INVOICES } from './types';

const initialState = Map({
  elements: List(),
  isLoading: true,
});

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_INVOICES.REQUEST: {
      const invoicesCount = state.get('elements').size;
      // If there are prefetched invoices, don't show the spinner
      return state.set('isLoading', invoicesCount === 0);
    }
    case FETCH_INVOICES.SUCCESS: {
      const descSortedInvoices = payload.sort((first, second) => (
        new Date(second.created_at) - new Date(first.created_at)
      ));
      return state.withMutations((newState) => {
        newState
          .set('elements', List(descSortedInvoices))
          .set('isLoading', false);
      });
    }
    case FETCH_INVOICES.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('isLoading', false)
          .set('elements', initialState.get('elements'));
      });
    default:
      return state;
  }
};
